module.exports = __webpack_public_path__ + "img/gachita_1_1.36226c87.png";